import { isArray, sortBy } from "lodash";
import { put, call, takeLatest } from "redux-saga/effects";
import * as Action from "us.collection.case/actions";
import { CaseDelay } from "us.collection.case/constants/Actions";
import * as API from "us.collection.case/services";
import { $MessageBox } from "us.common/components";
import { AccountSummeryWidgetActions } from "us.collection.case/actions";
import { CaseType } from "us.helper/types/enums";

const { CaseDelayAction } = Action;
const { delay } = API.caseDelayService;

const caseDelaySagas = {
  save: function* (action: any): Generator<any, void, any> {
    const params = action.payload.data;
    try {
      const { data, status } = yield call(delay.save, params);
      if (status === 200 && !data?.isError) {
        const result = yield call(API.dashboard.getAccountSummeryDetails, {
          EntityType: params?.entityType === CaseType.S ? "Subcase" : "Case",
          EntityId: params?.caseNo,
        });
        yield put(AccountSummeryWidgetActions.accountSummery.success(result));

        $MessageBox(
          "success",
          "US.COLLECTION.CASE:CASE_DELAY.DELAY_PAYMENT_SUCCESSFULLY",
          "",
          ""
        );
        yield put(CaseDelayAction.delay.success(data));
      } else {
        $MessageBox(
          "error",
          "US.COLLECTION.CASE:CASE_DELAY.DELAY_PAYMENT_FAIL",
          "",
          ""
        );
        yield put(CaseDelayAction.delay.fail(data));
      }
    } catch (error) {
      yield put(CaseDelayAction.delay.fail(error as any));
    }
  },
};

export default [
  takeLatest(CaseDelay.SAVE_CASE_DELAY_START, caseDelaySagas.save),
];
